// extracted by mini-css-extract-plugin
module.exports = {"UserPic":"style_UserPic__foR8j","UserInitials":"style_UserInitials__1h1DK"};